import React, { useCallback, useEffect, useState } from "react"
import styled from "styled-components"
import { useForm } from "react-hook-form"
import { AnalyticsService } from "@motorata/base-ui.services.segment-service";
import Modal from "@motorata/base-ui.components.molecules.modal"
import { Box } from "@motorata/base-ui.components.atoms._atoms"
import Button from "@motorata/base-ui.components.atoms.button"
import { P } from "@motorata/base-ui.components.atoms.typography"
import Alert from "@motorata/base-ui.components.molecules.alert"
import Input from "@motorata/base-ui.components.atoms.input";
import { PHONE_STRING_REGEX } from "@motorata/base-ui.utils.regex";
import Link from "next/link";
import Checkbox from "@motorata/base-ui.components.atoms.checkbox";
import { removeSpacesFromPhoneNumber } from "@motorata/base-ui.utils.string";
import { SentryService } from "@motorata/base-ui.services.sentry-service";
import { TagManagerService } from "@motorata/base-ui.services.tag-manager-service";
import { useStoreInfo } from "../../hooks/useStoreInfo"
import { MessageService } from "../../services/MessageService"

const OfferModalMessageContent = ({ id, type, brand, model, profile, show, setShow }) => {
  const deviceId = useStoreInfo()

  const {
    register,
    handleSubmit,
    watch,
    setValue,
    reset,
    formState: { errors },
  } = useForm()

  const checkbox = watch("checkbox");

  const [loading, setLoading] = useState(false)

  const analyticsParams = {
    productType: type,
    brand: brand,
    model: model,
    profileSlug: profile.slug,
    profileName: profile.name,
  }

  const onSubmit = useCallback(
    async el => {
      try {
        setLoading(true)
        await MessageService.addChat(profile.id, id, {
          deviceId,
          name: el.name,
          phone: removeSpacesFromPhoneNumber(el.phone),
          messages: [
            {
              message: el.message,
              dtCreated: new Date(),
            },
          ],
        })
        TagManagerService.truck("lead_message")
        AnalyticsService.track("Offer Message Send", analyticsParams)
        setShow("success")
      } catch (e) {
        SentryService.error("[ERROR MessageService.addChat API]", e)
      } finally {
        setLoading(false)
      }
    },
    [deviceId],
  )

  useEffect(() => {
    if (show) {
      AnalyticsService.track("Offer Message Open", analyticsParams)
    }
    if(!show){
      reset()
    }
  }, [show])

  return (
    <>
      <P small>
        Podaj niezbędne dane kontaktowe, a nasz doradca <span>{profile.name}</span> skontaktuje się
        z Tobą tak szybko jak to możliwe.
      </P>
      <Alert type="success" small>
        Kontakt bezpośrednio z wystawiającym.
      </Alert>
      <Content onSubmit={handleSubmit(onSubmit)}>
        <StyledGrid>
          <Input
            name="name"
            label="Imię i nazwisko*"
            error={errors.name}
            value={watch('name')}
            rhf={register("name", {
              required: true,
            })}
          />
          <Input
            name="phone"
            label="Telefon"
            error={errors.phone}
            elementType="pattern"
            format="+48 ### ### ###"
            formattedValue={true}
            value={watch('phone')}
            rhf={register("phone", {
              pattern: {
                value: PHONE_STRING_REGEX,
                message: "Niepoprawny format telefonu. +48 123 456 789",
              },
            })}
          />
        </StyledGrid>
        <Input
          name="message"
          label="Wiadomość*"
          error={errors.message}
          multiline={true}
          rows={4}
          maxRows={4}
          value={watch('message')}
          rhf={register("message", {
            required: true,
          })}
          marginBottom="S"
        />
        <Box mb="20px">
          <Checkbox
            name="checkbox"
            value={checkbox}
            error={errors.checkbox}
            rhf={register("checkbox", {
              required: true,
            })}
          >
            *Oświadczam, że zapoznałem/-am się z <Link href="/regulamin">Regulaminem</Link> i <Link href="/polityka-prywatnosci">Polityką prywatności</Link> oraz akceptuję ich postanowienia.
          </Checkbox>
        </Box>
        <Button loading={loading} submit width="100%">
          Wyślij
        </Button>
      </Content>
    </>
  )
}

const OfferModalMessage = ({ id, type, brand, model, profile, show, setShow }) => {
  return (
    <Modal title="Wyślij wiadomość" show={show} setShow={setShow} maxWidth="600px">
      <OfferModalMessageContent id={id} type={type} brand={brand} model={model} profile={profile} show={show} setShow={setShow} />
    </Modal>
  )
}

export default OfferModalMessage

const StyledGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: ${({ theme }) => theme.space.S};
  margin-bottom: ${({ theme }) => theme.space.S};

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`

const Content = styled.form``
